import routerOptions0 from "/Users/lion/Documents/work/outwork/website/nuxt3-template/node_modules/.pnpm/nuxt@3.10.0_eslint@8.56.0_sass@1.70.0/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}